import React from 'react'
import { ComponentWithAs, IconProps, Stack, Text } from '@chakra-ui/react'
import { Link, LinkProps, useResolvedPath, useLocation } from 'react-router-dom'

type Props = LinkProps & {
  Icon: ComponentWithAs<'svg', IconProps>
  iconWidth: string | number
  iconHeight: string | number
  TextWrapper?: React.FC
}

export const CustomLink: React.FC<Props> = ({
  Icon,
  iconWidth,
  iconHeight,
  children,
  to,
  TextWrapper,
  ...props
}) => {
  const location = useLocation()
  const resolved = useResolvedPath(to)

  const currentUrl = new URL(window.location.origin + location.pathname + location.search)
  const linkUrl = new URL(window.location.origin + resolved.pathname + resolved.search)

  const normalizePath = (path: string) => path.replace(/\/$/, '')

  const exactMatch =
    normalizePath(currentUrl.pathname) === normalizePath(linkUrl.pathname) &&
    Array.from(currentUrl.searchParams.entries()).sort().toString() ===
      Array.from(linkUrl.searchParams.entries()).sort().toString()

  const isDashboardActive =
    to === '/dashboard' && normalizePath(currentUrl.pathname) === '/dashboard'

  const isActive = exactMatch || isDashboardActive

  return (
    <Link to={to} {...props}>
      <Stack
        as="li"
        direction="row"
        w="full"
        alignItems="center"
        backgroundColor="transparent"
        py={3}
      >
        <Icon
          color={isActive ? '#157FEE' : 'icon.terirary'}
          w={iconWidth}
          h={iconHeight}
          minWidth="36px"
        />
        {TextWrapper ? (
          <TextWrapper>
            <Text fontSize="14px" color={isActive ? '#157FEE' : '#707070'}>
              {children}
            </Text>
          </TextWrapper>
        ) : (
          <Text fontSize="14px" color={isActive ? '#157FEE' : '#707070'}>
            {children}
          </Text>
        )}
      </Stack>
    </Link>
  )
}
